import React, { Component } from "react";
import styles from "./SectionTitle.module.css";
import Media from "react-media";

export default class Title extends Component {
  render() {
    return (
      <Media query="(max-width: 415px)">
        {(matches) =>
          matches ? (
            <h2 className={styles.title} style={this.props.style}>
              {this.props.children}
            </h2>
          ) : (
            <h2 style={this.props.style} className={styles.title}>
              {this.props.children}
            </h2>
          )
        }
      </Media>
    );
  }
}
